<template>
  <v-card>
    <v-toolbar
      dark
      prominent
      src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
    >
      <v-btn icon>
        <v-icon @click="$router.go(-1)">mdi-backspace</v-icon>
      </v-btn>

      <v-toolbar-title>Permissions </v-toolbar-title>

      <v-spacer></v-spacer>
    </v-toolbar>
    <v-container fluid grid-list-xl>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 lg2 d-flex>
          <v-select
            :items="roles"
            v-model="role"
            v-on:change="nullPerm"
            label="Roles"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 lg2 d-flex>
          <v-select
            :items="prepareSelect(modules)"
            v-model="module"
            v-if="role"
            label="Modules"
            v-on:change="nullPerm"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout v-if="module" wrap align-center>
        <v-flex
          xs12
          sm6
          lg4
          d-flex
          v-for="perm in role_perms[role].filter((item) =>
            item.startsWith(module)
          )"
          :key="perm"
        >
          <v-alert
            type="success"
            close-text="Revoke Permission"
            dense
            dismissible
            v-on:input="sendChanges(role, perm, false)"
            :key="perm"
          >
            {{
              perm
                .split("-")
                .slice(1)
                .join(" ")
                .split("_")
                .join(" ")
                .split(" ")
                .map((word) => {
                  return word[0].toUpperCase() + word.substring(1);
                })
                .join(" ")
            }}
          </v-alert>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 lg2 d-flex>
          <v-select
            :items="prepareSelect(tree[module].actions)"
            v-if="module"
            v-model="action"
            label="Action"
            v-on:change="addPerm"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 lg2 d-flex>
          <v-select
            :items="prepareSelect(tree[module].scopes)"
            v-if="module"
            v-model="scope"
            label="Scope"
            v-on:change="addPerm"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-container>
    <div class="text-center">
      <v-snackbar v-model="snackbar" :multi-line="true">
        {{ snackbar_text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-card>
</template>

<script>
export default {
  components: {},
  data: () => ({
    tree: {},
    role_perms: {},
    roles: [],
    perms: [],
    role: "",
    module: "",
    action: "",
    scope: "",
    snackbar: false,
    snackbar_text: "",
  }),
  methods: {
    updateAttendance(id, val) {
      this.$sisApi("post", "permissions", { id: id, result: val })
        .then((response) => {
          var i = this.students.findIndex((st) => st.id == id);
          this.students[i].result = val;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.log(error.response);
          }
        });
    },
    connectEditor() {
      this.connect = true;
    },
    prepareSelect(array) {
      return array.map((item) => {
        return {
          value: item,
          text: item
            .split("_")
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(" "),
        };
      });
    },
    addPerm() {
      if (this.action && this.scope) {
        let perm = [this.module, this.action, this.scope].join("-");
        this.role_perms[this.role].push(perm);
        this.sendChanges(this.role, perm, true);
      }
    },
    nullPerm() {
      this.action = "";
      this.scope = "";
    },
    sendChanges(role, perm, status) {
      this.$sisApi("post", "permissions", { role, perm, status })
        .then((response) => {
          this.snackbar = true;
          this.snackbar_text = response.data;
        })
        .catch((error) => {
          this.snackbar = true;
          this.snackbar_text = error.response.data.message;
        });
    },
  },
  mounted() {
    this.$sisApi("get", "permissions")
      .then((response) => {
        this.roles = response.data.roles;
        this.perms = response.data.perms;
        this.tree = response.data.tree;
        this.modules = Object.keys(response.data.tree);
        this.role_perms = response.data.role_perms;
      })
      .catch((error) => {
          console.log(error);
      });
  },
};
</script>
